module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/gamepad-2-61a054580ac8de481bbf651fbee2e7ab.svg";